module.exports = __webpack_public_path__ + "static/media/frog(2).3f47b5b8.PNG";